import { useExternalFeatureLayers } from 'features/mapping/hooks/useExternalFeatureLayers';
import { ExternalFeatureLayer } from 'features/mapping/mapping.types';

export const useFilteredExternalFeatureLayers = (
  shortNameIncludes: string[],
): ExternalFeatureLayer[] => {
  const { externalFeatureLayers } = useExternalFeatureLayers();

  return externalFeatureLayers.filter(
    (featureLayer) =>
      shortNameIncludes.some((identifier) =>
        featureLayer.shortName.includes(identifier),
      ) && featureLayer.hasAnyFeatures,
  );
};
